
export function timeout<T>(ms: number, promise: Promise<T>): Promise<T> {
    const timeoutPromise: Promise<T> = new Promise((_, reject) => {
        setTimeout(() => reject("Timeout expired"), ms);
    });

    return Promise.race<T>([timeoutPromise, promise]);
}
export const defaultTimeout = 1000 * 20;


// WEBPACK FOOTER //
// ./ClientApp/app/services/timeout.ts